export default __webpack_public_path__ + "static/media/active-timeline.b85573e6.png";